import { useL10NStore} from '@/stores/i18n.store';

export default class I18nService {
  store = useL10NStore();
  $t(key, params) {
    return this.store.i18n.global.t(key, params);
  }
}